module.exports = __webpack_public_path__ + "img/genuine.ac1a9b77.jpeg";